export default __webpack_public_path__ + "static/media/video-calls.4a890e57.jpg";